import Vue from 'vue'
import * as peers from '@/services/user/peers'

export const namespaced = true

export const state = {
    peers: [{}]
}

export const mutations = {
    LOAD(state, peers) {
        peers.forEach(peer => {
            // merge state with new peers array whilst overwriting duplicates
            // check if duplicates exist
            if (state.peers.find(({ _id }) => _id === peer._id)) {
                Vue.set(
                    state.peers,
                    state.peers.findIndex(statePeer => statePeer._id === peer._id),
                    peer
                )
            } else state.peers.push(peer)
        })
    },
    LOAD_ONE(state, newPeer) {
        Vue.set(
            state.peers,
            state.peers.findIndex(peer => peer._id === newPeer._id),
            newPeer
        )
    },
    REMOVE(state, id) {
        state.peers.splice(state.peers.findIndex(peer => peer._id === id), 1)
    }
}

export const actions = {
    load({ commit }) {
        return peers.load().then(result => commit('LOAD', result.peers))
    },
    loadByDevice({ commit }, deviceName) {
        return peers.loadByDevice(deviceName).then(result => commit('LOAD', result.peers))
    },
    loadByID({ commit }, id) {
        return peers.loadByID(id).then(result => commit('LOAD_ONE', result.peers[0]))
    },
    add(context, peer) {
        return peers.add(peer)
    },
    save({ commit }, peer) {
        return peers.save(peer).then(() => commit('LOAD_ONE', peer))
    },
    remove({ commit }, id) {
        return peers.remove(id).then(() => commit('REMOVE', id))
    }
}

export const getters = {
    getByDevice: state => deviceName => state.peers
        .filter(peer => peer.deviceName === deviceName),
    getByID: state => id => state.peers.find(peer => peer._id === id)
}